module.exports = __webpack_public_path__ + "img/lightLava.3305e004.jpg";